export default class UserGroups {
  static hasGroup(group) {
    const groups = $("body").data("groups");
    return groups.indexOf(group) >= 0;
  }
}
